import React, { useCallback, useContext, useEffect, useState } from "react";

import styles from "./style.module.scss";

import { MainContext } from "../../context/MainContext";
import Modal from "../Modal/Modal";

function UsersAction() {
  const { action, setOpenModal } = useContext(MainContext);
  const [arrayAction, setArrayAction] = useState([]);
  const [open, setOpen] = useState(false);
  const [itemData, setItemData] = useState({});

  useEffect(() => {
    getArrayAction();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [action]);

  const parseCustomDate = (dateString) => {
    const [datePart, timePart] = dateString.split(" ");
    const [day, month, year] = datePart.split(".").map(Number);
    const [hours, minutes] = timePart.split(":").map(Number);

    return new Date(year, month - 1, day, hours, minutes);
  };

  useEffect(() => {
    if (!open) {
      setItemData({});
    }
  }, [open]);

  const handleOpenModal = (item) => {
    setItemData(item);
    setOpen(true);
  };

  const getArrayAction = useCallback(() => {
    const array = [];
    action.forEach((elem) => {
      const element = elem.actions.slice(-100);
      element.forEach((item) => {
        if (item.typeName) {
          array.push(item);
        } else {
          const typeName = { typeName: elem.type };
          array.push({ ...item, ...typeName });
        }
      });
    });

    const arraySort = array.sort((a, b) => {
      const dateA = parseCustomDate(a.time);
      const dateB = parseCustomDate(b.time);

      return dateB - dateA;
    });
    setArrayAction(arraySort);
  }, [action]);

  const getType = (type) => {
    if (type === "entry user") {
      return "Вход пользователя";
    }
    if (type === "repair") {
      return "Ремонт";
    }
    if (type === "comment") {
      return "Комментарий добавлен";
    }
    if (type === "info") {
      return "Информация добавлена";
    }if (type === "service") {
      return "Добавленно ТО";
    }
  };

  return (
    <>
      <div className={styles.container}>
        <div className={styles.action__header}>
          <h1 className={styles.action__header__title}>Активные действия</h1>
        </div>
        {arrayAction &&
          arrayAction.map((item, index) => (
            <div key={index} className={styles.action}>
              <div className={styles.action__container}>
                <div className={styles.action__wrapper}>
                  <p className={styles.action__text__action}>{getType(item.typeName)}</p>
                </div>
                <div className={styles.action__wrapper}>
                  <p className={styles.action__text__name}>{item.name}</p>
                  <p>{"\u00A0"}</p>
                  <p className={styles.action__text}>{item.time}</p>
                </div>
              </div>
              <div className={styles.action__container}>
                <button className={styles.action__btn} onClick={() => handleOpenModal(item)}>
                  Подробней
                </button>
              </div>
            </div>
          ))}
      </div>
      {open && (
        <Modal setOpenModal={setOpenModal} onClose={setOpen}>
          {itemData.typeName === "entry user" && (
            <div className={styles.action__modal}>
              <h3 className={styles.action__modal__title}>Данные пользователя</h3>
              <p className={styles.action__modal__text}>
                Пользователь {itemData.name} вошел в систему
              </p>
              <p className={styles.action__modal__text}>Входа в систему {itemData.time} </p>
              <p className={styles.action__modal__text}>id {itemData.id}</p>
            </div>
          )}
          {itemData.typeName === "comment" && (
            <div className={styles.action__modal}>
              <h3 className={styles.action__modal__title}>
                Пользователь {itemData.name} добавил комментарии
              </h3>
              <p className={styles.action__modal__text}>Время добавления {itemData.time}</p>
              <p className={styles.action__modal__text}>
                Объект id:{itemData.id} имя:{itemData.nameObj}
              </p>
              <p className={styles.action__modal__text}>Адрес объекта: {itemData.address}</p>
              <p className={styles.action__modal__text}>Комментарий: {itemData.comment}</p>
              <p className={styles.action__modal__text}>id {itemData.id}</p>
            </div>
          )}
          {itemData.typeName === "repair" && (
            <div className={styles.action__modal}>
              <h3 className={styles.action__modal__title}>Ремонт</h3>
              <p className={styles.action__modal__text}>
                Пользователь {itemData.name} {!itemData.repair ? "снял" : "поставил"} Объект
              </p>
              <p className={styles.action__modal__text}>
                {!itemData.repair ? "с ремонта" : "в ремонт"}
              </p>
              <p className={styles.action__modal__text}>id: {itemData.id}</p>
              <p className={styles.action__modal__text}>Название: {itemData.nameObj}</p>
              <p className={styles.action__modal__text}>Адрес: {itemData.address}</p>

              <p className={styles.action__modal__text}>Время добавления {itemData.time} </p>
            </div>
          )}
          {itemData.typeName === "info" && (
            <div className={styles.action__modal}>
              <h3 className={styles.action__modal__title}>Изменение информации</h3>
              <p className={styles.action__modal__text}>
                Пользователь {itemData.name} изменил информацию
              </p>
              <p className={styles.action__modal__text}>
                Имя: {itemData.contact.name ? itemData.contact.name : "Не указано"}
              </p>
              <p className={styles.action__modal__text}>
                Телефон: {itemData.contact.tel ? itemData.contact.tel : "Не указано"}
              </p>
              <p className={styles.action__modal__text}>id: {itemData.id}</p>
              <p className={styles.action__modal__text}>Название: {itemData.nameObj}</p>
              <p className={styles.action__modal__text}>Адрес: {itemData.address}</p>
              <p className={styles.action__modal__text}>Время добавления {itemData.time} </p>
            </div>
          )}
          {itemData.typeName === "service" && (
            <div className={styles.action__modal}>
              <h3 className={styles.action__modal__title}>Добавленно ТО {itemData.date}</h3>
              <p className={styles.action__modal__text}>Пользователь {itemData.name} добавил ТО</p>
              <p className={styles.action__modal__text}>id: {itemData.id}</p>
              <p className={styles.action__modal__text}>Название: {itemData.nameObj}</p>
              <p className={styles.action__modal__text}>Адрес: {itemData.address}</p>
              <p className={styles.action__modal__text}>Время добавления {itemData.time} </p>
            </div>
          )}
        </Modal>
      )}
    </>
  );
}

export default UsersAction;
